module.exports = __webpack_public_path__ + "static/media/SubscriptionThankYou2.9724d550.gif";


//////////////////
// WEBPACK FOOTER
// ./src/SubscriptionThankYou2.gif
// module id = 607
// module chunks = 0